export default __webpack_public_path__ + "static/media/pub2.8d97f979.svg";